import { FC } from 'react';

import CategoryIcon from '@mui/icons-material/Category';
import Button from '@mui/material/Button';
import ToolCard from 'components/ToolCard';

const CategoriesCard: FC = () => (
  <ToolCard
    icon={<CategoryIcon fontSize="large" />}
    title="Kategorijos"
    description="Pasiūlymų kategorijų redagavimas"
    action={
      <Button href="categories" startIcon={<CategoryIcon />} size="small">
        Redaguoti
      </Button>
    }
  />
);

export default CategoriesCard;
